"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromBlankMinutes = void 0;
function fromBlankMinutes(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, clearAllSegments = utils.clearAllSegments, use = utils.use, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal;
    describe('Minutes - From blank', function () {
        incrementBlankMinutes();
        decrementBlankMinutes();
        function incrementBlankMinutes() {
            describe('increment blank minutes', function () {
                it('Should increment blank minutes 08:-- PM to 01:30 PM', function () {
                    loadPrimaryInput({ segment: 'minutes' })
                        .then(use.del)
                        .should('have.value', '08:-- PM')
                        .then(hasReturnVal(''))
                        .then(use.upArrow)
                        .should('have.value', '08:00 PM')
                        .then(a11yHasExpectedHtml("<p>0.</p>"))
                        .then(hasReturnVal('20:00'));
                });
                it('Should increment blank minutes from --:-- -- to --:00 --', function () {
                    loadPrimaryInput().then(function () {
                        clearAllSegments('minutes')
                            .then(use.upArrow)
                            .should('have.value', '--:00 --')
                            .then(a11yHasExpectedHtml("<p>0.</p>"))
                            .then(hasReturnVal(''));
                    });
                });
            });
        }
        function decrementBlankMinutes() {
            describe('decrement blank minutes', function () {
                it('Should decrement blank minutes 08:-- PM to 08:59 PM', function () {
                    loadPrimaryInput({ segment: 'minutes' })
                        .then(use.del)
                        .should('have.value', '08:-- PM')
                        .then(hasReturnVal(''))
                        .then(use.downArrow)
                        .should('have.value', '08:59 PM')
                        .then(a11yHasExpectedHtml("<p>59.</p>"))
                        .then(hasReturnVal('20:59'));
                });
                it('Should decrement blank minutes from --:-- -- to --:59 --', function () {
                    loadPrimaryInput({ segment: 'minutes' }).then(function () {
                        clearAllSegments('minutes')
                            .then(use.downArrow)
                            .should('have.value', '--:59 --')
                            .then(a11yHasExpectedHtml("<p>59.</p>"))
                            .then(hasReturnVal(''));
                    });
                });
            });
        }
    });
}
exports.fromBlankMinutes = fromBlankMinutes;
